import React from 'react';
import { Link } from 'react-router-dom'
import MessageUI from '../widgets/output/MessageUI'
import './PrivateFooter.css'

const PrivateFooterUI = ({context, messageList}) =>
  <div className='t_pvt_footer g_flex_h'>
    {
      context.session.appCode === 'finapp' &&
      <React.Fragment>
        <FooterItemUI context={context} itemLink='/home'
          messageList={messageList} messageKey='c_home'
        />
        {/*
        <FooterItemUI context={context} itemLink='/reports'
          messageList={messageList} messageKey='c_reports'
        />
        <FooterItemUI context={context} itemLink='/alerts'
          messageList={messageList} messageKey='c_alerts'
        />
        */}
      </React.Fragment>
    }
    {
      context.session.appCode === 'projectapp' &&
      <React.Fragment>
        <FooterItemUI context={context} itemLink='/projects'
          messageList={messageList} messageKey='c_projects'
        />
      </React.Fragment>
    }
    <FooterItemUI context={context} itemLink='/settings'
      messageList={messageList} messageKey='c_settings'
    />
  </div>

const FooterItemUI = ({context, messageList, messageKey, itemLink}) =>
  <Link className='f_link' to={itemLink}>
    <MessageUI messageList={messageList} messageKey={messageKey} />
  </Link>

export default PrivateFooterUI
